import React, {useContext, useEffect, useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import * as yup from 'yup';
import { useHistory} from "react-router-dom";
import {useFormik } from 'formik';
import axios from 'axios';
//import PropTypes from 'prop-types';
import {endpoint_auth_signin} from 'config';
import { UserContext } from 'UserContext';
import {useDispatch} from "react-redux";
import {loginUser,  fetchDashboardUsers} from "../../app/actions/actions";

function Copyright() {
    return (
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '}
        <Link color="inherit" href="https://ali-ramdani.netlify.app/">
          ADSIL
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: `url('${process.env.PUBLIC_URL}/images/PHOTO-DE-COUVERTURE-ADSIL-(1920-x-1080)-copie.jpg')`,
    content : 'adsil login photo',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.light,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(10, 0, 2),
  },
}));


const validationSchema = yup.object({
    email: yup
      .string('Enter your email')
      .email('Enter a valid email')
      .required('Email is required'),
    password: yup
      .string('Enter your password')
      .min(6, 'Password should be of minimum 8 characters length')
      .required('Password is required'),
});

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
/* props {setToken} */
export default function Login() {
  const classes = useStyles();

  /* Function to redirect */
  const history = useHistory();

  /* LOGIN ERROR */
  const [isError, setIsError] = useState(false);

  /* CONTEXT */
  const {setToken} = useContext(UserContext);
  const [userMail , setUserMail]= useState('');
  const dispatch = useDispatch() ;
  useEffect(()=>{
      if(userMail.length){
          dispatch(loginUser(userMail));
      }
  })

  /* FORM CONTROLLER */
  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: validationSchema,

    onSubmit: (data) => {
        axios({
            method: 'post',
            url: endpoint_auth_signin , 
            headers: { 
              'Content-Type': 'application/json' , 
            },
            data : data
        })
        .then(async (response) => {
            setToken(response.data.data.token)
            console.log('RESPONSE TOKEN =', response.data);
            localStorage.setItem('token', response.data.data.token);
            localStorage.setItem('authorities' , JSON.stringify(response.data.data.admin.authorities));
            await

            /* TEST MIDDLE WARE ROLE ADMIN BY DEFAULT */
            localStorage.setItem('role', 'admin');
            localStorage.setItem('mail' , data.email)
            console.log('the mail =' , data.email);
            // dispatch(fetchDashboardUsers(data.email));



            // setUserMail(data.mail);
            // setTimeout(()=>{
            //     dispatch(loginUser(data.email))
            // },2000)

        })
        .then(()=>{
            history.push('/');
            window.location.reload(false);
        })
        .catch((error) => {
            console.log(error);
            setIsError(true);
        })
        // sleep(100);
    }
  });

  return (
    <Grid container component="main" className={classes.root}>
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign In
          </Typography>
          <form className={classes.form} onSubmit={formik.handleSubmit}>
            <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
            />
            <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={formik.values.password}
                onChange={formik.handleChange}
                error={formik.touched.password && Boolean(formik.errors.password)}
                helperText={formik.touched.password && formik.errors.password}
            />

 
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="secondary"
              className={classes.submit}
            >
              CONNECT
            </Button>

            {isError? 
              <Box mt={8}>
                <Typography variant="body2" color="error" align="center">
                  email or password incorrect ! please verify your id
                </Typography>
              </Box>
            : ''}

            <Box mt={5}>
              <Copyright />
            </Box>
          </form>
        </div>
      </Grid>
    </Grid>
  );
}

